import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Breadcrumb } from "../../components";
import PageLayout from "../../layouts/PageLayout";
import data from "../../data/master/ecommerce.json";
import { Box, Item, Anchor } from "../../components/elements";
import {
  EcommerceCard,
  SalesCard,
  ProductsCard,
  RevenueCard,
  ClientsCard,
  ActivityCard,
  OrdersCard,
} from "../../components/cards";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { useEffect } from "react";

export default function Ecommerce() {
  const token = localStorage.getItem("token");

  const navigate = useNavigate();

  const checkToken = async () => {
    await axios
      .get(`${process.env.REACT_APP_BASE_URL}admin/check-token`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log(res.data);
      })
      .catch((e) => {
        localStorage.clear();
        navigate("/login");
      });
  };

  useEffect(() => {
    checkToken();
  }, []);

  return (
    <>
      {token ? (
        <>
          <PageLayout>
            <Grid container spacing={3}>
              <Grid size={12}>
                <Box className="mc-card">
                  <Breadcrumb title={data?.pageTitle}>
                    {data?.breadcrumb?.map((item, index) => (
                      <Item key={index} className="mc-breadcrumb-item">
                        {item.path ? (
                          <Anchor
                            className="mc-breadcrumb-link"
                            href={item.path}
                          >
                            {item.text}
                          </Anchor>
                        ) : (
                          item.text
                        )}
                      </Item>
                    ))}
                  </Breadcrumb>
                </Box>
              </Grid>
              {/* <Grid size={12}>
                <Grid container spacing={3}>
                  {data?.heros?.map((item, index) => (
                    <Grid size={{ xs: 12, sm: 6 }} key={index}>
                      <EcommerceCard
                        icon={item.icon}
                        trend={item.trend}
                        title={item.title}
                        number={item.number}
                        variant={item.variant}
                        percent={item.percent}
                        compare={item.compare}
                        dotsMenu={item.dotsMenu}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid> */}
              {/* <Grid size={{ xs: 12, xl: 4 }}>
                    <SalesCard
                        title={data?.sales.title}
                        amount={data?.sales.amount}
                        percent={data?.sales.percent}
                        trendIcon={data?.sales.trendIcon}
                        dotsMenu={data?.sales.dotsMenu}
                        compare={data?.sales.compare}
                        chart={data?.sales.chart}
                    />
                </Grid>
                <Grid size={12}>
                    <ProductsCard
                        title={data?.products.title}
                        dotsMenu={data?.products.dotsMenu}
                        table={data?.products.table}
                    />
                </Grid>
                <Grid size={{ xs: 12, xl: 8 }}>
                    <RevenueCard
                        title={data?.revenue.title}
                        field={data?.revenue.field}
                        report={data?.revenue.report}
                        chart={data?.revenue.chart}
                    />
                </Grid>
                <Grid size={{ xs: 12, xl: 4 }}>
                    <OrdersCard
                        title={data?.orders.title}
                        dotsMenu={data?.orders.dotsMenu}
                        items={data?.orders.items}
                    />
                </Grid>
                <Grid size={{ xs: 12, xl: 6 }}>
                    <ClientsCard
                        title={data?.clients.title}
                        dotsMenu={data?.clients.dotsMenu}
                        table={data?.clients.table}
                    />
                </Grid>
                <Grid size={{ xs: 12, xl: 6 }}>
                    <ActivityCard
                        title={data?.activity.title}
                        dotsMenu={data?.activity.dotsMenu}
                        items={data?.activity.items}
                    />
                </Grid> */}
            </Grid>
          </PageLayout>
        </>
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
}
